import { useState } from 'react';
import {
  Cart,
  CartItem,
  CartOptions,
  CartReducerAction,
  CartReducerActionType,
  CartResponseFields,
  CartStore,
} from '../../app/(routes)/online-ordering/types';
import { CartInitialState } from './initialState';

export const useAsyncReducer = (
  reducer: (
    state: CartStore,
    action: CartReducerAction
  ) => Promise<CartStore | Cart | CartResponseFields | CartItem | CartOptions | null | undefined>,
  initialState = CartInitialState
) => {
  const [state, setState] = useState<CartStore>(initialState);

  const dispatch = async (
    action: CartReducerAction,
    callback?: (state: CartStore | Cart | CartResponseFields | CartItem | CartOptions | null | undefined) => void
  ) => {
    try {
      const result = await reducer(state, action);

      if (result?.error) throw new Error(result?.error);
      if (callback) callback(result);

      if (
        result &&
        (action.type === CartReducerActionType.SyncCart ||
          action.type === CartReducerActionType.SaveAndSyncCart ||
          action.type === CartReducerActionType.SyncLocalCart ||
          action.type === CartReducerActionType.AddToCart ||
          action.type === CartReducerActionType.RemoveFromCart ||
          action.type === CartReducerActionType.UpdateInCart ||
          action.type === CartReducerActionType.IncrementInCart ||
          action.type === CartReducerActionType.DecrementInCart ||
          action.type === CartReducerActionType.DeleteItem ||
          action.type === CartReducerActionType.SetState ||
          action.type === CartReducerActionType.Reset ||
          action.type === CartReducerActionType.AddDealItems ||
          action.type === CartReducerActionType.RemoveDealItems ||
          action.type === CartReducerActionType.CheckDecrementPricing ||
          action.type === CartReducerActionType.CheckDeletePricing ||
          action.type === CartReducerActionType.CheckUpdatePricing)
      ) {
        const cartData: Cart = result as Cart;

        setState((prevState) => {
          return {
            ...prevState,
            cart: {
              ...prevState.cart,
              ...cartData,
            },
          };
        });
      } else if (result && action.type === CartReducerActionType.ToggleCartOption) {
        const cartData: CartOptions = result as CartOptions;

        setState((prevState) => {
          return {
            ...prevState,
            cartOptions: {
              ...prevState.cartOptions,
              ...cartData,
            },
          };
        });
      } else if (result) {
        setState((prevState) => {
          return {
            ...prevState,
            ...result,
          };
        });
      }
    } catch (err) {
      console.error('Error: ', err);
      setState((prevState) => {
        return {
          ...prevState,
          error: err,
        };
      });
    }
  };

  return [state, dispatch] as const;
};
